"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminStudentViewRoadmapController = /** @class */ (function () {
    function AdminStudentViewRoadmapController($stateParams, $window, RoadmapsModel, FlashService, roadmaps) {
        this.$stateParams = $stateParams;
        this.$window = $window;
        this.RoadmapsModel = RoadmapsModel;
        this.FlashService = FlashService;
        this.roadmaps = roadmaps;
        this.requirements = [];
        this.currentLesson = null;
        this.loading = true;
        this.assigning = false;
        this.error = "";
        this.onAssign = this.assign.bind(this);
        this.onClear = this.clear.bind(this);
        this.fetch();
    }
    AdminStudentViewRoadmapController.prototype.studentId = function () {
        return this.$stateParams.userId;
    };
    AdminStudentViewRoadmapController.prototype.fetch = function () {
        var _this = this;
        this.loading = true;
        this.RoadmapsModel.getStudentRoadmap(this.studentId())
            .then(function (response) {
            _this.requirements = response.requirements;
            _this.currentLesson = response.current_lesson;
            _this.loading = false;
        })
            .catch(function () {
            _this.error = "Failed to load the student's roadmap.";
            _this.loading = false;
        });
    };
    AdminStudentViewRoadmapController.prototype.assign = function (roadmapId) {
        var _this = this;
        if (this.requirements.length > 0 &&
            this.$window.confirm("Assigning a roadmap replaces the lessons this student hasn't completed yet. Continue?") === false) {
            return;
        }
        this.assigning = true;
        this.error = "";
        this.RoadmapsModel.assignToStudent(this.studentId(), roadmapId)
            .then(function (response) {
            _this.FlashService.setMessage({
                message: response.message,
                type: "success",
            });
            _this.assigning = false;
            _this.fetch();
        })
            .catch(function () {
            _this.error = "Failed to assign the roadmap.";
            _this.assigning = false;
        });
    };
    AdminStudentViewRoadmapController.prototype.clear = function () {
        var _this = this;
        var confirm = this.$window.confirm("Clear this student's roadmap? Lessons they haven't completed will be removed.");
        if (confirm === false) {
            return;
        }
        this.assigning = true;
        this.error = "";
        this.RoadmapsModel.clearStudentRoadmap(this.studentId())
            .then(function (response) {
            _this.FlashService.setMessage({
                message: response.message,
                type: "success",
            });
            _this.assigning = false;
            _this.fetch();
        })
            .catch(function () {
            _this.error = "Failed to clear the roadmap.";
            _this.assigning = false;
        });
    };
    return AdminStudentViewRoadmapController;
}());
AdminStudentViewRoadmapController.$inject = [
    "$stateParams",
    "$window",
    "RoadmapsModel",
    "FlashService",
    "roadmaps",
];
exports.default = AdminStudentViewRoadmapController;
